import React, { useCallback, useState, useEffect, type ReactNode } from 'react';
import { ExperienceTrackerContext, ExperienceTracker } from '@atlassian/experience-tracker';
import { sliSubscriber } from '../../services/sli-subscriber/index.tsx';

type Props = {
	children: ReactNode;
	orgId?: string;
	workspaceId?: string;
};

// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
const useUnmount = (callback: () => void) => useEffect(() => callback, [callback]);

export const ExperienceTrackerProvider = ({ children }: Props) => {
	const [experienceTracker] = useState(new ExperienceTracker());
	const [cleanupSliSub] = useState(() => experienceTracker.subscribe(sliSubscriber));

	const cleanup = useCallback(() => {
		cleanupSliSub();
	}, [cleanupSliSub]);

	useUnmount(cleanup);

	return (
		<ExperienceTrackerContext.Provider value={experienceTracker}>
			{children}
		</ExperienceTrackerContext.Provider>
	);
};
